import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bank-data-list" }
const _hoisted_2 = { class: "highlighted-content-text" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "bank-transfer-code" }
const _hoisted_5 = { key: 1 }

import ContentCopier from '@src/components/shared/ContentCopier.vue';

interface Props {
	bankTransferCode?: String;
	bankTransferAmount?: String;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BankData',
  props: {
    bankTransferCode: {},
    bankTransferAmount: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", null, [
      _createVNode(ContentCopier, {
        label: _ctx.$t( 'bank_data_account_owner' ),
        value: _ctx.$t( 'bank_data_operator_account_owner' )
      }, null, 8, ["label", "value"])
    ]),
    _createElementVNode("li", _hoisted_2, [
      _createVNode(ContentCopier, {
        label: _ctx.$t( 'bank_data_iban'),
        value: _ctx.$t( 'bank_data_operator_account_iban' ),
        "copy-value": _ctx.$t( 'bank_data_operator_account_iban' ).replaceAll( ' ', '' )
      }, null, 8, ["label", "value", "copy-value"])
    ]),
    _createElementVNode("li", null, [
      _createVNode(ContentCopier, {
        label: _ctx.$t( 'bank_data_bic'),
        value: _ctx.$t( 'bank_data_operator_account_bic')
      }, null, 8, ["label", "value"])
    ]),
    _createElementVNode("li", null, _toDisplayString(_ctx.$t( 'bank_data_operator_bank_name')), 1),
    (__props.bankTransferAmount)
      ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t( 'bank_data_transfer_amount_label' )) + ": ", 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(__props.bankTransferAmount), 1)
        ]))
      : _createCommentVNode("", true),
    (__props.bankTransferCode)
      ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
          _createVNode(ContentCopier, {
            label: _ctx.$t( 'bank_data_transfer_code' ),
            value: __props.bankTransferCode.toString()
          }, null, 8, ["label", "value"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})